import { ReactElement, useMemo } from 'react';

import {
  DiscountCard,
  IDiscountCardProps,
} from '../bonus-cards';
import { BonusType, IBonusesData } from '../../../../../graphql/bonuses/models/get-bonuses.models';
import { IBonusCards } from '../my-bonuses.models';
import { IPromotionCardProps, PromotionCard } from '../../user-activity-items/promotions';
import { LoyaltyType } from '../../../../../graphql/promotions/models/get-promotions.models';
import { localizeSecondVoucher, replaceWelcomeVoucher } from '../utils/replace-welcome-voucher';

interface IBonusesParams {
  bonuses?: IBonusesData;
  balance?: number;
  hasFittings: boolean;
  hasPurchases: boolean;
}

export const useGetBonuses = ({
  hasFittings, bonuses, balance, hasPurchases,
}: IBonusesParams): IBonusCards => {
  const result = useMemo(() => {
    let discounts: ReactElement<IDiscountCardProps>[] = [];
    let promotions: ReactElement<IPromotionCardProps>[] = [];

    if (bonuses && balance !== undefined) {
      discounts = bonuses.voucherByAuthId
        .filter(({ type }) => type === BonusType.discount)
        .map(({ value }, index) => (
          <DiscountCard
            id={index}
            isActivationMode={!hasFittings && balance >= Number(value)}
            isAvailable={balance >= Number(value)}
            balance={balance}
            value={Number(value)}
          />
        ));

      // Add second welcome voucher if there is the first welcome voucher
      const promoBonuses = bonuses.voucherByAuthId.filter(
        voucher => voucher.type === BonusType.custom || voucher.type === BonusType.loyalty,
      );
      const firstVoucher = promoBonuses.find((
        promotion,
      ) => promotion.type === BonusType.loyalty && promotion.name === LoyaltyType.discountFirstPurchase);

      promotions = firstVoucher ? replaceWelcomeVoucher(promoBonuses)
        .map((promotion) => (
          <PromotionCard
            id={`${promotion?.id}${promotion?.endDate}`}
            promotion={promotion!}
            isAvailable={!(promotion?.name === LoyaltyType.discountSecondPurchase)}
            isFirstWelcomeVoucher={promotion?.name === LoyaltyType.discountFirstPurchase}
          />
        )) : localizeSecondVoucher(promoBonuses).map((promotion) => (
        <PromotionCard
          id={`${promotion?.id}${promotion?.endDate}`}
          promotion={promotion}
          notClickable={promotion?.name === LoyaltyType.discountSecondPurchase}
        />
      ));
    }

    return {
      discounts,
      promotions,
    };
  }, [
    bonuses,
    balance,
    hasFittings,
    hasPurchases,
  ]);

  return result;
};
